import React from 'react'
import styles from './FirmwareUpdateDialog.module.css'
import { getBrandDeviceName } from '../../../hooks/useBrandConfig'
const FirmwareUpdateDialog = ({
    isOpen,
    currentVersion,
    latestVersion,
    deviceName,
    onUpdate,
    onSkip,
    onClose,
    mandatory,
}) => {
    if (!isOpen) return null

    const isPeeCee = sessionStorage.getItem('connectedDevice') === 'Ace'
    const canSkip = !mandatory && !isPeeCee && currentVersion !== latestVersion

    return (
        <div className={styles.overlay}>
            <div className={styles.modal}>
                <button
                    aria-label="Close"
                    className={styles.closeButton}
                    onClick={onClose || onSkip}
                />
                <div className={styles.header}>
                    <h2>{mandatory ? "Firmware Update Required" : currentVersion !== latestVersion ? "Firmware Update Available" : "Your device is UpTo Date"}</h2>
                </div>

                <div className={styles.content}>
                    <div className={styles.deviceInfo}>
                        <p className={styles.deviceName}>{getBrandDeviceName(deviceName)}</p>
                        <div className={styles.versionComparison}>
                            <div className={styles.versionBox}>
                                <span className={styles.versionLabel}>Current Version</span>
                                <span className={styles.versionNumber}>{currentVersion}</span>
                            </div>
                            <div className={styles.arrow}>→</div>
                            <div className={styles.versionBox}>
                                <span className={styles.versionLabel}>Latest Version</span>
                                <span className={styles.versionNumber + ' ' + styles.latest}>{latestVersion}</span>
                            </div>
                        </div>
                    </div>

                    <div className={styles.message}>
                        <p>{mandatory ? "This firmware version is no longer supported. Please update to continue." : currentVersion !== latestVersion ? "A new firmware version is available for your device." : "The current version is already updated"}</p>
                        {currentVersion !== latestVersion && <p className={styles.warning}>
                            ⚠️ Updating firmware will require you to disconnect and reconnect your device.
                        </p>}
                    </div>

                    <div className={styles.actions}>
                        <button className={styles.updateButton} disabled={currentVersion === latestVersion} style={{
                            opacity: `${currentVersion === latestVersion ? .5 : 1}`
                        }} onClick={onUpdate}>
                            Update Firmware
                        </button>
                        {canSkip && (
                            <button
                                className={styles.skipButton}
                                onClick={onSkip}
                            >
                                Skip for now
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FirmwareUpdateDialog
